var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { createUser, updateUser } from "../../../resources/helper/userHelper";
import { getClient } from "../../../resources/helper/helper";
import LocalStorageService from "../../../services/localStorage";
import { useBranchesGetAll } from "../../../fnx/branches/branchesGetAll";
import { useIdentificationTypeGetAll } from "../../../fnx/identificationType/identificationTypeGetAll";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useForm } from "react-hook-form";
var genderOptions = [
    {
        id: "M",
        name: "Masculino",
        label: "Masculino",
        value: "M",
    },
    {
        id: "F",
        name: "Femenino",
        label: "Femenino",
        value: "F",
    },
];
var intermediaryOptions = [
    {
        id: "1",
        name: "Intermediario 1",
        label: "Intermediario 1",
        value: "1",
    },
];
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var useCreateUserForm = function (setSeeToast) {
    var _a = useState(false), openDrawer = _a[0], setOpenDrawer = _a[1];
    var _b = useState(null), selectedUser = _b[0], setSelectedUser = _b[1];
    var formCreateUser = useForm({
        mode: "onChange",
        defaultValues: {
            firstName: "",
            lastName: "",
            birthDate: "",
            idType: "",
            idNumber: "",
            gender: "",
            username: "",
            email: "",
            password: "",
            confirmPassword: "",
            company: "",
            branch: "",
            intermediary: "",
        },
    });
    var _c = useState([]), clients = _c[0], setClients = _c[1];
    var _d = useState([]), identificationTypes = _d[0], setIdentificationTypes = _d[1];
    var _e = useState([]), branches = _e[0], setBranches = _e[1];
    var _f = useState(false), loadingCreateUser = _f[0], setLoadingCreateUser = _f[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var branchId = React.useState(lsLogin.getUserLoginStored().branchId)[0];
    useEffect(function () {
        var fetchClients = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getClient(true, 1, 10)];
                    case 1:
                        response = _b.sent();
                        if (response === null || response === void 0 ? void 0 : response.data) {
                            setClients((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.map(function (client) { return ({
                                id: client.id,
                                name: client.description,
                                label: client.description,
                                value: client.id,
                            }); }));
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchClients();
    }, []);
    var _g = useBranchesGetAll(true, clientId, "", ""), responseBranches = _g.responseBranches, errorBranches = _g.errorBranches, loadingBranches = _g.loadingBranches;
    var _h = useIdentificationTypeGetAll(true, "", "", 1, 20), responseIdentificationType = _h.responseIdentificationType, errorIdentificationType = _h.errorIdentificationType, loadingIdentificationType = _h.loadingIdentificationType;
    useEffect(function () {
        var _a;
        if (responseIdentificationType && (responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data)) {
            setIdentificationTypes((_a = responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                id: item.code,
                name: item.description,
                label: item.description,
                value: item.code,
            }); }));
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        if (responseBranches && (responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.length) > 0) {
            console.log("responseBranches", responseBranches);
            setBranches(responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.map(function (item) { return ({
                id: item.id,
                name: item.name,
                label: item.name,
                value: item.id,
            }); }));
        }
    }, [responseBranches]);
    // Efecto para cargar los datos del usuario seleccionado en el formulario
    useEffect(function () {
        if (selectedUser) {
            formCreateUser.reset({
                firstName: selectedUser.name,
                lastName: selectedUser.lastName,
                email: selectedUser.email,
                username: selectedUser.userName,
                company: selectedUser.clientId,
                branch: selectedUser.branchId,
                // Los demás campos se pueden agregar según necesidad
            });
        }
    }, [selectedUser]);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, user, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    values = formCreateUser.getValues();
                    user = {
                        name: values.firstName,
                        lastName: values.lastName,
                        email: values.email,
                        password: values.password,
                        passwordConfirm: values.confirmPassword,
                        clientId: values.company,
                        branchId: values.branch,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    setLoadingCreateUser(true);
                    response = void 0;
                    if (!selectedUser) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateUser(selectedUser.id, user)];
                case 2:
                    // Si hay un usuario seleccionado, actualizamos
                    response = _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createUser(user)];
                case 4:
                    // Si no hay usuario seleccionado, creamos uno nuevo
                    response = _a.sent();
                    _a.label = 5;
                case 5:
                    console.log("response", response);
                    if (response === null || response === void 0 ? void 0 : response.ok) {
                        setSeeToast({
                            show: true,
                            type: typeAlert.success,
                            message: selectedUser ? "Usuario actualizado correctamente" : "Usuario creado correctamente",
                        });
                        setOpenDrawer(false);
                        setSelectedUser(null);
                    }
                    else {
                        setSeeToast({
                            show: true,
                            type: typeAlert.error,
                            message: selectedUser ? "Error al actualizar el usuario" : "Error al crear el usuario",
                        });
                    }
                    return [3 /*break*/, 8];
                case 6:
                    error_1 = _a.sent();
                    setSeeToast({
                        show: true,
                        type: typeAlert.error,
                        message: selectedUser ? "Error al actualizar el usuario" : "Error al crear el usuario",
                    });
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingCreateUser(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return {
        openDrawer: openDrawer,
        setOpenDrawer: setOpenDrawer,
        onSubmit: onSubmit,
        idTypeOptions: identificationTypes,
        genderOptions: genderOptions,
        companyOptions: clients,
        branchOptions: branches,
        intermediaryOptions: intermediaryOptions,
        loadingCreateUser: loadingCreateUser,
        formCreateUser: formCreateUser,
        selectedUser: selectedUser,
        setSelectedUser: setSelectedUser,
        isEditing: !!selectedUser
    };
};
